import {
  Typography,
  captionTypography,
  mediumBodyTypography,
  neutral80,
} from '@leaftrade/leaftrade-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { currencyFormatter } from '../../../utils';
import {
  QuickOrderFooterTotal,
  QuickOrderFooterTotals,
} from './QuickOrderTable.styles';

const QuickOrderTableTotals = ({ totalItems, totalPrice }) => (
  <QuickOrderFooterTotals>
    <QuickOrderFooterTotal>
      <Typography bodyStyle={captionTypography} sx={{ color: neutral80.hex }}>
        Quantity
      </Typography>
      <Typography bodyStyle={mediumBodyTypography}>
        {totalItems || 0}
      </Typography>
    </QuickOrderFooterTotal>
    <QuickOrderFooterTotal>
      <Typography bodyStyle={captionTypography} sx={{ color: neutral80.hex }}>
        Subtotal
      </Typography>
      <Typography bodyStyle={mediumBodyTypography}>
        {currencyFormatter.format(totalPrice || 0)}
      </Typography>
    </QuickOrderFooterTotal>
  </QuickOrderFooterTotals>
);

QuickOrderTableTotals.propTypes = {
  totalItems: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
};

export default QuickOrderTableTotals;
